export interface StatusHeroProps {
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    title: string;
    description: string;
    subDescription?: string;
}

export function StatusHero({ icon: Icon, title, description, subDescription }: StatusHeroProps) {
    return (
        <section className="bg-white shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="text-center">
                    <Icon className="h-16 w-16 text-blue-600 mx-auto mb-6" />
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">
                        {title}
                    </h1>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                        {description}
                    </p>
                    {subDescription && (
                        <div className="mt-4 text-sm text-gray-500">
                            {subDescription}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
